/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProjectDetails } from "interfaces/IProject";
import { httpApi } from "./http.api";

//hiring/job/

export const getProjects = (
  page: number,
  isTalentPool?: boolean,
  page_size = 10,
  filterType = "",
  searchString = ""
): Promise<{
  results: ProjectDetails[];
  count: number;
  page: number;
  filterType?: string;
  next: string | null;
  total_pages: number;
}> =>
  httpApi
    .get<any>(
      `hiring/job/?page=${page}&page_size=${page_size}&project_filter=${filterType}&search=${searchString}&is_talent_pool=${
        typeof isTalentPool === "boolean" ? (isTalentPool ? "True" : "False") : "False"
      }`
    )
    .then(({ data }) => data);

export const getProject = (): Promise<{
  results: ProjectDetails[];
  count: number;
  page: number;
  next: string | null;
  total_pages: number;
}> => httpApi.get<any>(`hiring/job/`).then(({ data }) => data);

export const getProjectDetail = (id: number): Promise<any> =>
  httpApi.get<any>(`hiring/job/${id}`).then(({ data }) => data);

export const getTalentPools = (
  page: number
): Promise<{
  results: ProjectDetails[];
  count: number;
  page: number;
  next: string | null;
  total_pages: number;
}> => httpApi.get<any>(`hiring/job/?is_talent_pool=True&page=${page}`).then(({ data }) => data);

export const createProject = (formData: FormData): Promise<any> =>
  httpApi
    .post<any>("hiring/job/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);

export const importProject = (ats_job_id: any): Promise<any> =>
  httpApi.post<any>("ats/import-project/", { ats_job_id: ats_job_id }).then(({ data }) => data);

export const deleteProject = async (id: number, poolId?: number | null): Promise<any> => {
  const queryString = poolId ? `?poolId=${poolId}` : "";
  return httpApi.delete<any>(`hiring/job/${id}/${queryString}`);
};

export const updateRole = (roleId: number, rolePayload: any): Promise<any> =>
  httpApi.patch<any>("hiring/job/" + roleId + "/", rolePayload).then(({ data }) => data);

export const addCandidateToRole = (Payload: any): Promise<any> => {
  return httpApi
    .post<any>("hiring/custom-assignment/add-candidate-to-job/", {
      ...Payload,
    })
    .then(({ data }) => data);
};

export const deleteProjects = (jobIds: number[], poolId?: number | null): Promise<any> =>
  httpApi
    .post<any>("hiring/delete-jobs/", {
      jobs: jobIds,
      poolId: poolId ?? undefined, // Include poolId only if it's provided
    })
    .then(({ data }) => data);

export const fetchAllContributors = (
  jobId: number,
  report_id?: number | string | null
): Promise<any> => {
  const params = new URLSearchParams();

  if (report_id) {
    // If report_id is provided, only send report_id
    params.append("report_id", report_id.toString());
  } else {
    // If no report_id, send resource_id
    params.append("resource_id", jobId.toString());
  }

  return httpApi
    .get<any>(`hiring/share-job/get-all-team-members/?${params.toString()}`)
    .then(({ data }) => data);
};

export const fetchReportContributors = (report_id: number | string): Promise<any> => {
  return httpApi
    .get<any>(`report/share-report/get-all-team-members?resource_id=${report_id}`)
    .then(({ data }) => data);
};

export const fetchProjectContributors = (jobId: number): Promise<any> =>
  httpApi
    .get<any>(`hiring/share-job/get-contributors/?resource_id=${jobId}`)
    .then(({ data }) => data);

export const addProjectContributors = (
  jobIds: number[],
  contributorIds?: number[],
  report_id?: any
): Promise<any> =>
  httpApi
    .post<any>("hiring/share-job/add-contributors/", {
      resource_ids: jobIds,
      contributor_ids: contributorIds,
      report_id: report_id,
    })
    .then(({ data }) => data);

export const addReportContributors = (contributorIds: number[], report_id: any[]): Promise<any> =>
  httpApi
    .post<any>("report/share-report/add-contributors/", {
      resource_ids: report_id,
      contributor_ids: contributorIds,
    })
    .then(({ data }) => data);

export const addExternalContributors = (
  emails: string[],
  project_id: number,
  show_contact_info?: boolean,
  // templateId?: any,
  ccEmails?: any,
  emailBody?: any,
  emailSubject?: any,
  scoreCardInfo?: any,
  report_id?: any
): Promise<any> =>
  httpApi
    .post<any>("users/user-custom/external-contributor/", {
      emails: emails,
      show_contact_info: show_contact_info,
      project_id: !report_id ? project_id : null,
      // template_id: templateId,
      cc_emails: ccEmails,
      email_body: emailBody,
      email_subject: emailSubject,
      scorecard_info: scoreCardInfo,
      report_id,
    })
    .then(({ data }) => data);

export const fetchEmailTemplate = (project_id: number, templateId?: any): Promise<any> =>
  httpApi
    .post<any>("users/email-template-preview/", {
      project_id: project_id,
      template_id: templateId,
    })
    .then(({ data }) => data);

export const deleteProjectContributors = async (
  jobIds: number[],
  contributorIds?: number[]
): Promise<any> =>
  httpApi
    .post<any>("hiring/share-job/delete-contributors/", {
      job_ids: jobIds,
      contributor_ids: contributorIds, // Include poolId only if it's provided
    })
    .then(({ data }) => data);

export const duplicateProject = async (jobId: number): Promise<any> =>
  httpApi
    .post<any>("/hiring/duplicate-job/", {
      job_id: jobId,
    })
    .then(({ data }) => data);

export const updateProjectStatus = (projectStatus: string, projectId: number): Promise<any> => {
  const formData = new FormData();
  formData.append("status", projectStatus); // Add the status as form data

  return httpApi
    .patch<any>(`hiring/job/${projectId}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Specify that the content is form data
      },
    })
    .then(({ data }) => data);
};

export const getSearchProjectTitle = (title: string): Promise<any[]> =>
  httpApi.get<any[]>(`/hiring/job/?search=${title}`).then((data: any) => data.data);
